import { Directive, Input, HostListener, Optional, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[UiPontos]'
})
export class UiPontosDirective {

  @Input('UiCartao') valor: string;

  constructor( @Optional() private model: NgModel,
    private evento: ElementRef) { }

  @HostListener('focusout')
  focusout() {
    try {
      if (this.model !== null) {
        const valor = this.formatPontos(this.model.value);
        this.model.viewToModelUpdate(valor);
        this.model.valueAccessor.writeValue(valor);
      } else {
        this.evento.nativeElement.value = this.formatPontos(this.evento.nativeElement.value);
      }
    } catch (e) {

    }
  }

  public formatPontos(valor) {
    return valor.replace(/[^0-9]+/g, '');
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/diretives/ui-pontos.directive.ts